import React from "react";

import { useLanguage, useTranslation } from "utils";

import { ErrorBoundary, Flex, Layout, LazyLoadImage, MainPage, SelectLanguage, Svg, Typography } from "components";

const { Header } = Layout;

export const MaintenancePage = () => {
  const { t } = useTranslation("global");
  useLanguage();

  return (
    <MainPage pageName="maintenance" className="page">
      <section className="page">
        <Header className="" style={{ background: "none", margin: "3rem" }}>
          <Flex align="center" justify="space-between">
            <Svg svgName="logos/klim_logo_text_black" width={75} height={32} />
            <ErrorBoundary>
              <SelectLanguage placement="bottomRight" skipRefresh={false} />
            </ErrorBoundary>
          </Flex>
        </Header>
      </section>
      <Flex align="center" justify="center" gap="3rem" vertical style={{ height: "100%" }}>
        <Typography variant="h1" hero>
          {t("maintenance.title")}
        </Typography>
        <Typography variant="paragraph-xl">{t("maintenance.message")}</Typography>
        <div style={{ width: "50%", height: "50%" }}>
          <LazyLoadImage alt="hello" className="hero-image" src="/images/homepage/homepage_video.jpg" />
        </div>
      </Flex>
    </MainPage>
  );
};
